export enum ClickAdEventTarget {
  CloseButton = 'close_button',
  CloseClickOutsidePlacement = 'close_click_outside_placement',
  BackNavigationButton = 'close_back_nav',
  DigitalLabelOfferBanner = 'digital_label_offer_banner',
  Creative = 'creative',
  Cta = 'cta',
  AdInfo = 'ad_info',
  SecondaryButton = 'secondary_button',
  PrivacyPolicy = 'privacy_policy',
}
